import React from 'react';
import PropTypes from 'prop-types';
import useProductAttributes from 'data-hooks/useProductAttributes/index';
import useCylindoDimensionShots from 'data-hooks/useCylindoDimensionShots';
import PDPDimensionsContentUI from './PDPDimensionsContentUI';

const PDPDimensionsContent = ({
  isSidebarContent,
  onImageClick,
  pageLoading = false,
  upholsteryKey,
}) => {
  const {
    loading,
    error,
    data: { dimensions, custom_properties, boxDimensions },
  } = useProductAttributes();

  const dimensionShotsData = useCylindoDimensionShots({ upholsteryKey });

  if (error) {
    return null;
  }

  return (
    <PDPDimensionsContentUI
      loading={loading || pageLoading}
      dimensionsDesktopImage={custom_properties?.dimensional_image_desktop}
      dimensionsMobileImage={custom_properties?.dimensional_image_mobile}
      dimensions={dimensions}
      boxDimensions={boxDimensions}
      onImageClick={onImageClick}
      isSidebarContent={isSidebarContent}
      {...dimensionShotsData}
    />
  );
};

PDPDimensionsContent.propTypes = {
  isSidebarContent: PropTypes.bool,
  onImageClick: PropTypes.func,
  pageLoading: PropTypes.bool,
  upholsteryKey: PropTypes.string,
};

export default PDPDimensionsContent;
